module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fae3");
/******/ })
/************************************************************************/
/******/ ({

/***/ "5880":
/***/ (function(module, exports) {

module.exports = require("vuex");

/***/ }),

/***/ "60bb":
/***/ (function(module, exports) {

module.exports = require("lodash");

/***/ }),

/***/ "71cb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_NotificationsListNaoLidas_vue_vue_type_style_index_0_id_42242acc_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7c38");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_NotificationsListNaoLidas_vue_vue_type_style_index_0_id_42242acc_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_NotificationsListNaoLidas_vue_vue_type_style_index_0_id_42242acc_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "7c38":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "8875":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript')
    // for chrome
    if (!descriptor && 'currentScript' in document && document.currentScript) {
      return document.currentScript
    }

    // for other browsers with native support for currentScript
    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ "919f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_NotificationsListLidas_vue_vue_type_style_index_0_id_597e4b6b_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("da46");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_NotificationsListLidas_vue_vue_type_style_index_0_id_597e4b6b_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_NotificationsListLidas_vue_vue_type_style_index_0_id_597e4b6b_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "cebe":
/***/ (function(module, exports) {

module.exports = require("axios");

/***/ }),

/***/ "da46":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "fae3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "NotificacaoPlugin", function() { return /* reexport */ NotificacaoPlugin; });

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__("8875")
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"5623668a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/notifications/Notificacoes.vue?vue&type=template&id=2db06c43&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('px-notifications-list',{attrs:{"width":_vm.width},on:{"itens":_vm.onItens},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-badge',{class:_vm.badgeClass,attrs:{"color":_vm.badgeColor,"overlap":"","bottom":"","left":_vm.left,"value":_vm.value,"content":_vm.value}},[_c('v-btn',_vm._g({class:("mr-3 " + _vm.btnClass),attrs:{"icon":"","color":_vm.btnColor,"x-large":_vm.xLarge,"small":_vm.small}},on),[_c('v-icon',_vm._g({class:_vm.iconClass,attrs:{"x-large":_vm.xLarge}},on),[_vm._v(_vm._s(_vm.icon))])],1)],1)]}}])})],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/notifications/Notificacoes.vue?vue&type=template&id=2db06c43&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"5623668a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/notifications/NotificationsList.vue?vue&type=template&id=0dbe80c3&
var NotificationsListvue_type_template_id_0dbe80c3_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"offset-x":"","max-width":_vm.width,"min-width":_vm.width,"max-height":"500","close-on-content-click":false,"content-class":"menu-overflow","transition":"scale-transition"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_vm._t("activator",null,{"on":on})]}}],null,true),model:{value:(_vm.menuOpened),callback:function ($$v) {_vm.menuOpened=$$v},expression:"menuOpened"}},[_c('v-card',[_c('div',[_c('v-tabs',{attrs:{"fixed-tabs":""},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab',[_vm._v("Não lidas")]),_c('v-tab',[_vm._v("Lidas")])],1),_c('v-tabs-items',{model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab-item',[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('px-notifications-list-nao-lidas',{attrs:{"itens":_vm.itens,"loading":_vm.loading},on:{"clickItem":_vm.close,"remove":_vm.onRemove}})],1)],1)],1),_c('v-tab-item',[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[(_vm.tab === 1)?_c('px-notifications-list-lidas',{on:{"clickItem":_vm.close}}):_vm._e()],1)],1)],1)],1)],1)])],1)}
var NotificationsListvue_type_template_id_0dbe80c3_staticRenderFns = []


// CONCATENATED MODULE: ./src/notifications/NotificationsList.vue?vue&type=template&id=0dbe80c3&

// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__("5880");

// EXTERNAL MODULE: external "lodash"
var external_lodash_ = __webpack_require__("60bb");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"5623668a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/notifications/NotificationsListNaoLidas.vue?vue&type=template&id=42242acc&scoped=true&
var NotificationsListNaoLidasvue_type_template_id_42242acc_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parent-list-overflow"},[(_vm.loading)?_c('div',[_c('px-circular-loading')],1):_vm._e(),(_vm.itens.length)?_c('v-list',{staticClass:"list-overflow",attrs:{"max-height":"400"}},[_vm._l((_vm.itens),function(item,index){return [_c('px-notification',{key:item.sId,attrs:{"item":item},on:{"clickItem":_vm.onClickItem}}),(index < (_vm.itens.length - 1))?_c('v-divider',{key:("v-div-usr-f" + (item.sId))}):_vm._e()]})],2):_vm._e(),(!_vm.itens.length && !_vm.loading)?_c('div',{staticClass:"subtitle-1 mt-10 mb-10",attrs:{"align":"center"}},[_c('span',[_vm._v("Não há novas notificações por aqui")])]):_vm._e()],1)}
var NotificationsListNaoLidasvue_type_template_id_42242acc_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/notifications/NotificationsListNaoLidas.vue?vue&type=template&id=42242acc&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"5623668a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/notifications/Notification.vue?vue&type=template&id=412f98ee&
var Notificationvue_type_template_id_412f98ee_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',{on:{"click":_vm.onClickItem}},[_c('v-list-item-icon',[_c('v-icon',{attrs:{"large":""}},[_vm._v(_vm._s(_vm.icon))])],1),_c('v-list-item-content',{staticClass:"grey--text text--darken-1"},[_vm._v(" "+_vm._s(_vm.item.content)+" "),_c('small',{staticClass:"text-right"},[_vm._v(" "+_vm._s(_vm._f("dateDescription")(_vm.item.createdIn))+" ")])])],1)}
var Notificationvue_type_template_id_412f98ee_staticRenderFns = []


// CONCATENATED MODULE: ./src/notifications/Notification.vue?vue&type=template&id=412f98ee&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/notifications/Notification.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var Notificationvue_type_script_lang_js_ = ({
  props: {
    item: Object
  },
  computed: {
    icon() {
      return this.item.icon || 'mdi-currency-usd-circle-outline';
    }

  },
  methods: {
    extractPath(path) {
      return path.replace(/[0-9]/g, '');
    },

    onClickItem() {
      if (!this.item.system || this.item.system === this.$pxNotifications.SYSTEM) {
        this.onClickSameSystem();
        return;
      }

      this.onClickOtherSystem();
    },

    onClickOtherSystem() {
      if (this.item.system === 'MARKETPLACE') {
        window.open(`${this.$pxNotifications.URLS.MARKETPLACE}${this.item.linkTo}`, '_blank');
      }

      if (this.item.system === 'PROXPECT_COMPRA_CONJUNTA') {
        window.open(`${this.$pxNotifications.URLS.PROXPECT_COMPRA_CONJUNTA}${this.item.linkTo}`, '_blank');
      }

      if (this.item.system === 'PROXPECT') {
        window.open(`${this.$pxNotifications.URLS.PROXPECT}${this.item.linkTo}`, '_blank');
      }

      this.$emit('clickItem', this.item);
    },

    onClickSameSystem() {
      if (this.item.type === 'LINK') {
        const isSamePath = this.extractPath(this.$route.path) === this.extractPath(this.item.linkTo);

        if (this.$route.path !== this.item.linkTo) {
          this.$router.push({
            path: this.item.linkTo
          });

          if (isSamePath) {
            this.$router.go(0);
          }
        } else {
          this.$router.go(this.$router.currentRoute);
        }
      }

      this.$emit('clickItem', this.item);
    }

  }
});
// CONCATENATED MODULE: ./src/notifications/Notification.vue?vue&type=script&lang=js&
 /* harmony default export */ var notifications_Notificationvue_type_script_lang_js_ = (Notificationvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/notifications/Notification.vue





/* normalize component */

var component = normalizeComponent(
  notifications_Notificationvue_type_script_lang_js_,
  Notificationvue_type_template_id_412f98ee_render,
  Notificationvue_type_template_id_412f98ee_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Notification = (component.exports);
// EXTERNAL MODULE: external {"commonjs":"axios","commonjs2":"axios","amd":"axios","root":"axios"}
var external_commonjs_axios_commonjs2_axios_amd_axios_root_axios_ = __webpack_require__("cebe");
var external_commonjs_axios_commonjs2_axios_amd_axios_root_axios_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_axios_commonjs2_axios_amd_axios_root_axios_);

// CONCATENATED MODULE: ./src/notifications/notificacoes-service.js


const getNotifications = (url, query) => external_commonjs_axios_commonjs2_axios_amd_axios_root_axios_default.a.get(`/notifications?${query}`, {
  baseURL: url
});

const markRead = (url, item) => external_commonjs_axios_commonjs2_axios_amd_axios_root_axios_default.a.put('/notifications/read', item, {
  baseURL: url
});

/* harmony default export */ var notificacoes_service = ({
  getNotifications,
  markRead
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/notifications/NotificationsListNaoLidas.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var NotificationsListNaoLidasvue_type_script_lang_js_ = ({
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    itens: Array
  },

  data() {
    return {
      notificationsBasePath: this.$pxNotifications.API_URL_NOTIFICATIONS
    };
  },

  methods: {
    onClickItem(item) {
      notificacoes_service.markRead(this.notificationsBasePath, item);
      this.$emit('clickItem', item);
      this.$emit('remove', item);
    }

  },
  components: {
    pxNotification: Notification
  }
});
// CONCATENATED MODULE: ./src/notifications/NotificationsListNaoLidas.vue?vue&type=script&lang=js&
 /* harmony default export */ var notifications_NotificationsListNaoLidasvue_type_script_lang_js_ = (NotificationsListNaoLidasvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/notifications/NotificationsListNaoLidas.vue?vue&type=style&index=0&id=42242acc&scoped=true&lang=css&
var NotificationsListNaoLidasvue_type_style_index_0_id_42242acc_scoped_true_lang_css_ = __webpack_require__("71cb");

// CONCATENATED MODULE: ./src/notifications/NotificationsListNaoLidas.vue






/* normalize component */

var NotificationsListNaoLidas_component = normalizeComponent(
  notifications_NotificationsListNaoLidasvue_type_script_lang_js_,
  NotificationsListNaoLidasvue_type_template_id_42242acc_scoped_true_render,
  NotificationsListNaoLidasvue_type_template_id_42242acc_scoped_true_staticRenderFns,
  false,
  null,
  "42242acc",
  null
  
)

/* harmony default export */ var NotificationsListNaoLidas = (NotificationsListNaoLidas_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"5623668a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/notifications/NotificationsListLidas.vue?vue&type=template&id=597e4b6b&scoped=true&
var NotificationsListLidasvue_type_template_id_597e4b6b_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parent-list-overflow"},[(_vm.loading)?_c('div',[_c('px-circular-loading')],1):_vm._e(),(_vm.itens.length)?_c('v-list',{staticClass:"list-overflow",attrs:{"max-height":"400"}},[_vm._l((_vm.itens),function(item,index){return [_c('px-notification',{key:item.sId,attrs:{"item":item},on:{"clickItem":_vm.onClickItem}}),(index < (_vm.itens.length - 1))?_c('v-divider',{key:("v-div-usr-f" + (item.sId))}):_vm._e()]})],2):_vm._e(),(!_vm.itens.length && !_vm.loading)?_c('div',{staticClass:"subtitle-1 mt-10 mb-10",attrs:{"align":"center"}},[_c('span',[_vm._v("Não há notificações por aqui")])]):_vm._e()],1)}
var NotificationsListLidasvue_type_template_id_597e4b6b_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/notifications/NotificationsListLidas.vue?vue&type=template&id=597e4b6b&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/notifications/NotificationsListLidas.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var NotificationsListLidasvue_type_script_lang_js_ = ({
  data() {
    return {
      notificationsBasePath: this.$pxNotifications.API_URL_NOTIFICATIONS,
      loading: false,
      itens: []
    };
  },

  computed: { ...Object(external_vuex_["mapGetters"])('user', ['user'])
  },
  methods: {
    getNotificationsRead() {
      this.loading = true;
      notificacoes_service.getNotifications(this.notificationsBasePath, 'read=true').then(({
        data
      }) => {
        this.itens = data || [];
      }).finally(() => {
        this.loading = false;
      });
    },

    onClickItem(item) {
      this.$emit('clickItem', item);
    }

  },

  created() {
    this.getNotificationsRead();
  },

  components: {
    pxNotification: Notification
  }
});
// CONCATENATED MODULE: ./src/notifications/NotificationsListLidas.vue?vue&type=script&lang=js&
 /* harmony default export */ var notifications_NotificationsListLidasvue_type_script_lang_js_ = (NotificationsListLidasvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/notifications/NotificationsListLidas.vue?vue&type=style&index=0&id=597e4b6b&scoped=true&lang=css&
var NotificationsListLidasvue_type_style_index_0_id_597e4b6b_scoped_true_lang_css_ = __webpack_require__("919f");

// CONCATENATED MODULE: ./src/notifications/NotificationsListLidas.vue






/* normalize component */

var NotificationsListLidas_component = normalizeComponent(
  notifications_NotificationsListLidasvue_type_script_lang_js_,
  NotificationsListLidasvue_type_template_id_597e4b6b_scoped_true_render,
  NotificationsListLidasvue_type_template_id_597e4b6b_scoped_true_staticRenderFns,
  false,
  null,
  "597e4b6b",
  null
  
)

/* harmony default export */ var NotificationsListLidas = (NotificationsListLidas_component.exports);
// CONCATENATED MODULE: ./src/notifications/notification-websocket-service.js
function start(token, websocketHost, onMessage) {
  const connection = new WebSocket(`${websocketHost}?Authorizer=${token}`);

  connection.onerror = error => {
    // eslint-disable-next-line no-console
    console.error('Connection attempt failed', error);
  };

  connection.onopen = () => {
    setInterval(() => {
      const data = JSON.stringify({
        action: 'ping'
      });
      connection.send(data);
    }, 30000);
  };

  connection.onmessage = message => {
    const content = JSON.parse(message.data);
    onMessage(content);
  };

  return connection;
}

/* harmony default export */ var notification_websocket_service = ({
  start
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/notifications/NotificationsList.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var NotificationsListvue_type_script_lang_js_ = ({
  props: {
    width: {
      type: String,
      default: '450'
    }
  },

  data() {
    return {
      notificationsBasePath: this.$pxNotifications.API_URL_NOTIFICATIONS,
      websocketHost: this.$pxNotifications.SOCKET_URL_NOTIFICATIONS,
      windowTitle: this.$pxNotifications.WINDOW_TITLE,
      menuOpened: false,
      loading: false,
      tab: null,
      itens: []
    };
  },

  computed: { ...Object(external_vuex_["mapGetters"])('user', ['user']),
    ...Object(external_vuex_["mapGetters"])(['tokenHeader'])
  },
  methods: {
    updateTitle() {
      if (this.$pxNotifications.KEEP_TITLE) {
        return;
      }

      if (Object(external_lodash_["isEmpty"])(this.itens)) {
        document.title = this.windowTitle || 'Proxpect';
        return;
      }

      document.title = `(${this.itens.length}) ${this.windowTitle || 'Proxpect'}`;
    },

    emitItens() {
      this.updateTitle();
      this.$emit('itens', this.itens);
    },

    getNotificationsNotRead() {
      this.loading = true;
      notificacoes_service.getNotifications(this.notificationsBasePath, `userid=${this.user.id}`).then(({
        data
      }) => {
        this.itens = data || [];
        this.emitItens();
      }).finally(() => {
        this.loading = false;
      });
    },

    close() {
      this.menuOpened = false;
    },

    onRemove(item) {
      this.itens = this.itens.filter(i => i.sId !== item.sId);
      this.emitItens();
    },

    onNewMessage(message) {
      if (message.action === 'NEW_NOTIFICATION') {
        const notification = message.content;
        this.itens.unshift(notification);
        this.emitItens();
      }
    },

    initNotifications() {
      this.getNotificationsNotRead();
      notification_websocket_service.start(this.tokenHeader, this.websocketHost, this.onNewMessage);
    }

  },
  watch: {
    user(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }

      if (newValue) {
        this.initNotifications();
      }
    }

  },

  created() {
    this.tab = 0;

    if (this.user) {
      this.initNotifications();
    }
  },

  components: {
    pxNotificationsListNaoLidas: NotificationsListNaoLidas,
    pxNotificationsListLidas: NotificationsListLidas
  }
});
// CONCATENATED MODULE: ./src/notifications/NotificationsList.vue?vue&type=script&lang=js&
 /* harmony default export */ var notifications_NotificationsListvue_type_script_lang_js_ = (NotificationsListvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/notifications/NotificationsList.vue





/* normalize component */

var NotificationsList_component = normalizeComponent(
  notifications_NotificationsListvue_type_script_lang_js_,
  NotificationsListvue_type_template_id_0dbe80c3_render,
  NotificationsListvue_type_template_id_0dbe80c3_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var NotificationsList = (NotificationsList_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/notifications/Notificacoes.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Notificacoesvue_type_script_lang_js_ = ({
  props: {
    width: {
      type: String,
      default: '450'
    },
    icon: {
      type: String,
      default: 'mdi-bell'
    },
    iconClass: {
      type: String,
      default: ''
    },
    btnClass: {
      type: String,
      default: ''
    },
    badgeClass: {
      type: String,
      default: ''
    },
    badgeColor: {
      type: String,
      default: 'secondary'
    },
    small: {
      type: Boolean,
      default: true
    },
    xLarge: {
      type: Boolean,
      default: false
    },
    btnColor: {
      type: String
    },
    left: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      itens: []
    };
  },

  computed: {
    value() {
      return this.itens ? this.itens.length : 0;
    }

  },
  methods: {
    onItens(itens) {
      this.itens = itens;
    }

  },
  components: {
    pxNotificationsList: NotificationsList
  }
});
// CONCATENATED MODULE: ./src/notifications/Notificacoes.vue?vue&type=script&lang=js&
 /* harmony default export */ var notifications_Notificacoesvue_type_script_lang_js_ = (Notificacoesvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/notifications/Notificacoes.vue





/* normalize component */

var Notificacoes_component = normalizeComponent(
  notifications_Notificacoesvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Notificacoes = (Notificacoes_component.exports);
// CONCATENATED MODULE: ./src/notifications/notificacao-plugin.js

/* harmony default export */ var notificacao_plugin = ({
  /* eslint-disable no-param-reassign */
  install(Vue, options) {
    const pxOptions = {
      SOCKET_URL_NOTIFICATIONS: options.SOCKET_URL_NOTIFICATIONS || 'custom',
      API_URL_NOTIFICATIONS: options.API_URL_NOTIFICATIONS || '',
      SYSTEM: options.SYSTEM || 'PROXPECT',
      URLS: {
        PROXPECT: options.URL_PROXPECT || '',
        PROXPECT_COMPRA_CONJUNTA: options.URL_PROXPECT_COMPRA_CONJUNTA || '',
        MARKETPLACE: options.URL_PROXPECT_MARKETPLACE || ''
      },
      WINDOW_TITLE: options.WINDOW_TITLE || 'Proxpect',
      KEEP_TITLE: options.KEEP_TITLE
    };
    Vue.$pxNotifications = pxOptions;
    Vue.prototype.$pxNotifications = pxOptions;
    Vue.component('PxNotificacoes', Notificacoes);
  }

});
// CONCATENATED MODULE: ./src/main.js
 // eslint-disable-next-line import/prefer-default-export

const NotificacaoPlugin = notificacao_plugin;
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js




/***/ })

/******/ });
//# sourceMappingURL=pxNotifications.common.js.map